import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "./DoctorWebsite.js";
import MediaPage from "./Medya.js";
import ContactPage from "./İletişim.js";
import ReviewPage from "./Görüş.js";
import { LanguageProvider } from "./LanguageContext.js";
function App() {
  return (
    <LanguageProvider>
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/medya" element={<MediaPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/reviews" element={<ReviewPage />} />
        </Routes>
      </Router>
    </LanguageProvider>
  );
}

export default App;
